import Vue from 'vue'
import Honeybadger from '../honeybadger';

function embodia_vue_error_handler(err){
  const environment = process.env.NODE_ENV;

  if (environment === 'production'){
    Honeybadger.notify(err);
  }else{
    console.log(err);
    alert('Caught an error');
  }
}

Vue.config.errorHandler = function (err) {
  embodia_vue_error_handler(err)
};

export function reject_and_raise(error, reject, do_raise){
  const is_422 = error.response && error.response.status === 422;
  const is_401 = error.response && error.response.status === 401;

  if (do_raise || !is_422 || !is_401){
    embodia_vue_error_handler(error)
  }
  reject(error)
}